import React from "react";

export default function ChecklistSection({ sectionTitle, questions, data, setData }) {
  const update = (key, field, value) =>
    setData({ ...data, [key]: { ...data[key], [field]: value } });

  return (
    <div className="fra-card">
      <h3>{sectionTitle}</h3>
      <table className="fra-checklist-table">
        <thead>
          <tr>
            <th>Clause</th>
            <th>Question</th>
            <th>Yes</th>
            <th>No</th>
            <th>N/A</th>
            <th>Deficiencies / Comments</th>
            <th>Evidence</th>
          </tr>
        </thead>
        <tbody>
          {questions.map(q => (
            <tr key={q.key}>
              <td>{q.clause}</td>
              <td>
                {q.text}
                {q.subBullets && (
                  <ul style={{ margin: 0, paddingLeft: 16 }}>
                    {q.subBullets.map((txt, i) => <li key={i}>{txt}</li>)}
                  </ul>
                )}
              </td>
              {["Yes", "No", "N/A"].map(option => (
                <td key={option}>
                  <input
                    type="radio"
                    name={`${q.key}-answer`}
                    checked={data[q.key]?.answer === option}
                    onChange={() => update(q.key, "answer", option)}
                  />
                </td>
              ))}
              <td>
                <textarea
                  value={data[q.key]?.deficiencies || ""}
                  onChange={e => update(q.key, "deficiencies", e.target.value)}
                  placeholder="Deficiencies or further info"
                  rows={2}
                />
              </td>
              <td>
                <input
                  type="file"
                  accept="image/*"
                  onChange={e => update(q.key, "evidence", e.target.files?.[0])}
                />
                {data[q.key]?.evidence && (
                  <span style={{ fontSize: 10 }}>✔ Image attached</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
